import { Component, OnDestroy, AfterViewInit, Output, EventEmitter, ElementRef, forwardRef } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ngx-tiny-mce',
  template: '',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TinyMCEComponent),
      multi: true
    }
  ]
})
export class TinyMCEComponent implements OnDestroy, AfterViewInit,ControlValueAccessor {

  @Output() editorKeyup = new EventEmitter<any>();

  editor: any;

  constructor(
    private host: ElementRef,
    private locationStrategy: LocationStrategy,
  ) { }
  value: string;


  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {}

  registerOnTouched(fn: any) {}

  ngAfterViewInit() {
    tinymce.init({
      target: this.host.nativeElement,
      plugins: ['link', 'paste', 'table'],
      skin_url: `${this.locationStrategy.getBaseHref()}assets/skins/lightgray`,
      setup: editor => {
        this.editor = editor;
        editor.on('keyup', () => {
          this.editorKeyup.emit(editor.getContent());
        });
      },
      height: '320',
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

  resetContent() {
    if (this.editor) {
      this.editor.setContent('');
    }
  }


  setContent(content : string){
    if(this.editor){
      if (content == null){
      }
      this.editor.setContent(content);
    }
  }
}
